<template lang="html">

<div class="upload-img">
      <el-upload
        class="upload-demo"
        accept="image/*,.pdf"
        action="https://jsonplaceholder.typicode.com/posts/"
        :before-upload="beforeUpload"
        :on-remove="handleRemove"
        :file-list="fileList">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传 mp4 文件，且不超过 500M</div>
      </el-upload>
</div>

</template>

<script>
export default {
    data(){
        return{
            fileList: [
              {name: 'food.mp4', url: ''}
            ],

        }
    },
    methods:{
        beforeUpload:function(file){
            var isImage = file.type.split('\/')[0] === 'image';


            var isLt100M = file.size / 1024 / 1024 <= 500;
            if (!isLt100M) {
                this.$message.error('文件大小不能超过 500 MB!');
            }else{
                // this.postHead['X-Token'] = getToken();
                // this.postData.organizationMaterialId = this.id;
                // this.postData.code = this.code;
            }

            if(!isImage){
                this.$message.error('只能上传格式为 mp4 的文件');
            }

            return isLt100M && isImage;
        },
        handleRemove:function(){

        }
    }
}
</script>

<style lang="css" scoped>

.upload-img{
    width: 420px;
    padding-top: 2px;
}

.el-upload__tip{
    display: inline-block;
    margin-left: 12px;
}

</style>



// WEBPACK FOOTER //
// mvUpload.vue?f4eadc8a